import { z } from "zod";

/**
 * `Settings`（ドメイン層）の永続化形状のZodスキーマ。ドメイン層はzodに依存できないため、
 * スキーマはインフラ層に置く（`progress-schema.ts`と同じ方針。ADR-006）。
 * `.strict()`により未知のフィールドを拒否する。
 */
export const persistedSettingsSchema = z
  .object({
    schemaVersion: z.literal(1),
    volume: z.number().min(0).max(1),
    muted: z.boolean(),
    mobileGuideAcknowledged: z.boolean(),
    narrationSpeedMultiplier: z.number().positive(),
    reduceMotionOverride: z.boolean(),
  })
  .strict();

export type PersistedSettings = z.infer<typeof persistedSettingsSchema>;
